// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"5c5f847a","460":"4853a722","871":"ffbf3411"}[chunkId] + ".chunk.css";
};